import React from "react";
import { FiFileText, FiVideo, FiMusic, FiType, FiUpload, FiCpu, FiFile } from "react-icons/fi";

// Rasmlar – siz yuborgan 3-rasm va 4-rasmni shu joyga import qilamiz
import Preview1 from "../assets/test-result-pdf copy.webp"; // 3-rasm
import Preview2 from "../assets/test-result-website.webp"; // 4-rasm

export default function HowItWorks() {
  return (
    <section className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-4">

        {/* TITLE */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900">
            Qanday ishlaydi
          </h2>
          <p className="text-gray-500 mt-2">
            Chap tomonda material — o‘ng tomonda tayyor natija
          </p>
        </div>

        {/* GRID */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">

          {/* ========== CHAP BLOK ========== */}
          <div className="rounded-3xl border border-gray-200 shadow-sm p-8">

            <h3 className="text-xl font-semibold text-gray-900 mb-6">
              Material turlari
            </h3>

            {/* Material list */}
            <div className="space-y-5 mb-8">

              <div className="flex items-center gap-4">
                <div className="h-12 w-12 rounded-xl bg-gray-100 flex items-center justify-center">
                  <FiFileText className="text-gray-700 text-xl" />
                </div>
                <span className="text-gray-700">Hujjatlar (PDF, DOCX)</span>
              </div>

           

          

              <div className="flex items-center gap-4">
                <div className="h-12 w-12 rounded-xl bg-gray-100 flex items-center justify-center">
                  <FiType className="text-gray-700 text-xl" />
                </div>
                <span className="text-gray-700">Matnli materiallar</span>
              </div>

            </div>

            {/* Badge */}
            <div className="flex items-center gap-2 bg-gray-100 px-3 py-1 rounded-full text-sm text-gray-600 w-fit mb-10">
              <span className="h-2 w-2 rounded-full bg-gray-600"></span>
              Faylingizdan boshlang — bir necha daqiqada natija
            </div>

            {/* 4 steps */}
            <div className="grid grid-cols-1 gap-6">

              {/* Step 1 */}
              <div className="flex items-center gap-3 rounded-xl border border-gray-200 py-3 px-4 bg-white">
                <span className="h-7 w-7 flex items-center justify-center rounded-full bg-black text-white text-sm">1</span>
                <div>
                  <h4 className="text-gray-900 font-medium text-sm">Faylni yuklang</h4>
                  <div className="w-16 h-1 bg-gray-300 mt-1 rounded"></div>
                </div>
              </div>

              {/* Step 2 */}
              <div className="flex items-center gap-3 rounded-xl border border-gray-200 py-3 px-4 bg-white">
                <span className="h-7 w-7 flex items-center justify-center rounded-full bg-black text-white text-sm">2</span>
                <div>
                  <h4 className="text-gray-900 font-medium text-sm">AI tahlil qiladi</h4>
                  <div className="w-16 h-1 bg-gray-300 mt-1 rounded"></div>
                </div>
              </div>

              {/* Step 3 */}
              <div className="flex items-center gap-3 rounded-xl border border-gray-200 py-3 px-4 bg-white">
                <span className="h-7 w-7 flex items-center justify-center rounded-full bg-black text-white text-sm">3</span>
                <div>
                  <h4 className="text-gray-900 font-medium text-sm">Test yaratiladi</h4>
                  <div className="w-16 h-1 bg-gray-300 mt-1 rounded"></div>
                </div>
              </div>

              {/* Step 4 */}
              <div className="flex items-center gap-3 rounded-xl border border-gray-200 py-3 px-4 bg-white">
                <span className="h-7 w-7 flex items-center justify-center rounded-full bg-black text-white text-sm">4</span>
                <div>
                  <h4 className="text-gray-900 font-medium text-sm">PDF eksport qilinadi</h4>
                  <div className="w-16 h-1 bg-gray-300 mt-1 rounded"></div>
                </div>
              </div>

            </div>

          </div>

          {/* ========== O‘NG BLOK – 3 VA 4 RASM ========== */}
          <div className="relative">
            
            {/* Asosiy katta rasm */}
            <img
              src={Preview1}
              className="w-full rounded-3xl shadow-lg"
              alt="Preview 1"
            />

            {/* Pastdagi kichik rasm */}
            <img
              src={Preview2}
              className="
                absolute right-10 -bottom-10 w-[70%]
                rounded-3xl shadow-xl rotate-[2deg]
              "
              alt="Preview 2"
            />

          </div>

        </div>

      </div>
    </section>
  );
}
